require('../../fhApp/leftPad/leftPadFilter');

angular.module('app.shared.teamLineup.teamLineupController', [
  'app.leftPad.leftPadFilter'
])
  .controller('app.shared.teamLineup.teamLineupController', [
    '$scope', '$filter', '$interval', '$rootScope',
    function ($scope, $filter, $interval, $rootScope) {
      'use strict';

      let init, time_to_start;

      $scope.game = $scope.game || null;
      $scope.layout = $scope.layout || null;
      $scope.version = $scope.version || 1;
      $scope.countdown = null;
      $scope.countdown_timer = null;

      $scope.$on('enableGameSpoiler', function(event, data) {
        $scope.spoiled = data;
      });

      time_to_start = function () {
        let abs_minutes, game_time, hours, minutes, total_minutes;
        if ($scope.game) {
          game_time = moment($scope.game.dtegametimefixed);
          total_minutes = moment().diff(game_time, 'minutes');
          abs_minutes = Math.abs(total_minutes);
          hours = Math.floor(abs_minutes / 60);
          minutes = Math.floor(abs_minutes - (hours * 60));
          if ($scope.game.currently_streaming === true) {
            total_minutes = 0;
            hours = 0;
            minutes = 0;
          }
          return {
            total_minutes: total_minutes,
            hours: hours,
            minutes: minutes
          };
        }
      };
      init = function () {
        $scope.countdown = $scope.counter();
        if ($scope.countdown_timer) {
          $interval.cancel($scope.countdown_timer);
        }
        return $scope.countdown_timer = $interval(function () {
          return $scope.countdown = $scope.counter();
        }, 15000);
      };
      $scope.get_template_url = function () {
        let base_name;
        base_name = 'components/shared/teamLineup/views/teamLineupView-';
        if ($scope.layout) {
          return base_name + $scope.layout + '.html';
        } else {
          return base_name + 'default.html';
        }
      };
      $scope.counter = function () {
        let countdown;
        countdown = {
          tts: time_to_start()
        };
        if (countdown.tts) {
          if (countdown.tts.total_minutes < 0) {
            countdown.message = $filter('left_pad')(countdown.tts.hours, 2) + ' hrs ' + $filter('left_pad')(countdown.tts.minutes, 2) + ' mins';
          } else {
            countdown.message = 'Live Now!';
          }
        }
        return countdown;
      };
      $scope.is_live = function () {
        if ($scope.countdown && $scope.countdown.tts) {
          return $scope.countdown.tts.total_minutes >= 0;
        }
        return false;
      };
      $scope.$on('$destroy', () => {
        if ($scope.countdown_timer) {
          $interval.cancel($scope.countdown_timer);
        }
      });
      return $scope.$watch('$scope.game', function () {
        if ($scope.game) {
          return init();
        }
      });
    }
  ]);



// WEBPACK FOOTER //
// ./app.v2/components/shared/teamLineup/teamLineupController.js